var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.value,
        "content-class": _vm.dialogContentClass,
        "max-width": _vm.maxWidth,
        persistent: _vm.persistent,
        "no-click-animation": "",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "system-dialog__card", attrs: { elevation: "0" } },
        [
          _vm.showHeader
            ? _c("div", { staticClass: "system-dialog__header" }, [
                _c(
                  "h2",
                  { staticClass: "system-dialog__title" },
                  [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
                  2
                ),
                _vm.showClose
                  ? _c(
                      "button",
                      {
                        staticClass: "system-dialog__close",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("button.cancel"),
                        },
                        on: { click: _vm.onClose },
                      },
                      [
                        _c("v-icon", { attrs: { size: "18" } }, [
                          _vm._v("close"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "system-dialog__body", class: _vm.bodyAlignClass },
            [_vm._t("default")],
            2
          ),
          _vm.showActions
            ? _c(
                "div",
                {
                  staticClass: "system-dialog__actions",
                  class: _vm.actionsAlignClass,
                },
                [_vm._t("actions", null, { close: _vm.onClose })],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }